module.exports = __webpack_public_path__ + "static/media/info-lock.25b5228a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-lock.gif
// module id = 1751
// module chunks = 0